
import { Component } from "@angular/core";
import { NotificationService } from "../services/notification.service";

@Component({
    selector: "notification-ribbon",
    template: require("./notification.component.html")
})
export class NotificationComponent {
    constructor(private notify: NotificationService) {}
}


/** WEBPACK FOOTER **
 ** ./F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/app/notification/notification.component.ts
 **/